import * as React from 'react';
import useSubscription from './useSubscription';

const PREMIUM_NOTICE_STORAGE_PREFIX = 'premiumUnlockedNoticeDismissed_';

export default function usePremiumNotice() {
  const { isPremium, sub } = useSubscription();
  const premiumNoticeKey = sub?.subscription_id
    ? `${PREMIUM_NOTICE_STORAGE_PREFIX}${sub.subscription_id}`
    : null;
  const [showPremiumNotice, setShowPremiumNotice] = React.useState(false);

  React.useEffect(() => {
    if (isPremium && premiumNoticeKey) {
      setShowPremiumNotice(
        window.localStorage.getItem(premiumNoticeKey) !== 'true',
      );
    } else {
      setShowPremiumNotice(false);
    }
  }, [isPremium, premiumNoticeKey]);

  const dismissPremiumNotice = () => {
    if (premiumNoticeKey) {
      window.localStorage.setItem(premiumNoticeKey, 'true');
    }
    setShowPremiumNotice(false);
  };

  return { showPremiumNotice, dismissPremiumNotice };
}
